export default props => {
  const { value, fpsEnabled } = props

  return (
    <div className={`gameSpeed${fpsEnabled ? ' fpsEnabled' : ''}`}>
      <div className="label">{'Speed:'}</div>
      <span className="text">{value * 100}%</span>
    </div>
  )
}
